import { initializedSelector } from '@chegg-wt/core/state/app/selectors'
import { softLoggedInSelector, jwtSelector } from '@chegg-wt/core/state/user/selectors'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { refreshAndFetch } from '@chegg-wt/core/state/user/actions'

const useNoSoftLoggedIn = ({ skip }: { skip?: boolean } = {}): void => {
  const initialized = useSelector(initializedSelector)
  const softLoggedIn = useSelector(softLoggedInSelector)
  const jwt = useSelector(jwtSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!skip && initialized && softLoggedIn) {
      dispatch(refreshAndFetch(jwt))
    }
  }, [skip, initialized, softLoggedIn, dispatch])
}

export default useNoSoftLoggedIn
